<mat-toolbar class="secondary-toolbar mat-elevation-z1">
</mat-toolbar>

<section class="main-content">
  <mat-grid-list cols="3" gutterSize="20px" rowHeight="fit" style="height:100%">
    <mat-grid-tile colspan="2">
      <div class="dashboard-tile">
        <app-grid-spinner #spinner></app-grid-spinner>
        <div class="tile-header">
          <div class="tile-header-title">
            <span>Vertical Assessments</span>
            <span *ngIf="profileData['industry']" class="text-primary"> - {{profileData['industry']}} - {{profileData['employees']}} - {{profileData['location']}}</span>
          </div>
        </div>
        <div class="tile-content">
          <div class="table-wrapper" style="height:inherit;">
            <table mat-table [dataSource]="companyData" style="width:100%;" matSort matSortActive="name" matSortDisableClear matSortDirection="asc">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Company Name</th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
              </ng-container>

              <ng-container matColumnDef="percentile">
                <th mat-header-cell *matHeaderCellDef>Overall Percentile</th>
                <td mat-cell *matCellDef="let element">{{element.percentile}} %</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" (click)="selectCompany(row)" class="alternating-bg bg-accent-hover selectable" [ngClass]="{'bg-accent-selected':row == selectedCompany}"></tr>
            </table>
            <div class="d-flex">
              <mat-paginator [length]="resultsLength" [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons (page)="paginationChange($event)"></mat-paginator>
              <div class="go-to-container">
                <div class="go-to-label">Go To: </div>
                <mat-form-field>
                  <mat-select [(ngModel)]="goTo" (selectionChange)="goToPage()">
                    <mat-option *ngFor="let pageNumber of pageNumbers" [value]="pageNumber">{{pageNumber}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-grid-tile>
    <mat-grid-tile>
      <app-percentile-graph-component graphTitle="Overall Percentiles" [highlightScore]="selectedCompany?.assessmentScore" [parentAccount]="_sessionService.getCurrentAccount()"></app-percentile-graph-component>
    </mat-grid-tile>
    <mat-grid-tile>
      <app-percentile-graph-component *ngIf="profileData['industry']" graphTitle="Industry Percentiles" groupingField="INDUSTRY" [groupingValue]="profileData['industry']" [highlightScore]="selectedCompany?.assessmentScore" [parentAccount]="_sessionService.getCurrentAccount()"></app-percentile-graph-component>
    </mat-grid-tile>
    <mat-grid-tile>
      <app-percentile-graph-component *ngIf="profileData['employees']" graphTitle="Company Size Percentiles" groupingField="COMPANY_SIZE" [groupingValue]="profileData['employees']" [highlightScore]="selectedCompany?.assessmentScore" [parentAccount]="_sessionService.getCurrentAccount()"></app-percentile-graph-component>
    </mat-grid-tile>
    <mat-grid-tile>
      <app-percentile-graph-component *ngIf="profileData['location']" graphTitle="Geography Percentiles" groupingField="LOCATION" [groupingValue]="profileData['location']" [highlightScore]="selectedCompany?.assessmentScore" [parentAccount]="_sessionService.getCurrentAccount()"></app-percentile-graph-component>
    </mat-grid-tile>
  </mat-grid-list>
</section>
